"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var BlInput = react_1.forwardRef(function (_a, ref) {
    var _b, _c;
    var className = _a.className, inputClassName = _a.inputClassName, icon = _a.icon, _d = _a.type, type = _d === void 0 ? 'text' : _d, _e = _a.rounded, rounded = _e === void 0 ? false : _e, _f = _a.required, required = _f === void 0 ? false : _f, element = _a.element, rest = __rest(_a, ["className", "inputClassName", "icon", "type", "rounded", "required", "element"]);
    return (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.input_wrapper, className, (_b = {},
            _b[styles_module_scss_1.default.has_icon] = !!icon,
            _b[styles_module_scss_1.default.is_required] = !!required,
            _b)) },
        icon && react_1.default.createElement("i", { className: "cm-icon icon-" + icon }),
        required && (react_1.default.createElement("span", { className: classnames_1.default(styles_module_scss_1.default.right, styles_module_scss_1.default.required) })),
        react_1.default.createElement("input", __assign({ type: type, className: classnames_1.default((_c = {},
                _c[styles_module_scss_1.default.round] = rounded,
                _c[styles_module_scss_1.default.input_default] = !rounded,
                _c), inputClassName) }, rest, { ref: ref })),
        element && element));
});
exports.default = BlInput;
